import { createSelector } from '@reduxjs/toolkit'
import { Slice, CustomerOrder } from './types'

export const getSlice = (state: any): Slice => {
  return state.customer.orders
}

export const getFetching = (state: any) => {
  return getSlice(state).isFetching
}

export const getSuccess = (state: any) => {
  return getSlice(state).isSuccess
}

export const getFailure = (state: any) => {
  return getSlice(state).isFailure
}

export const getOrders = createSelector(
  getSlice,
  slice => {
    const items: CustomerOrder[] = [...slice?.payload?.items ?? []]
    return items.reverse()
  }
)
